import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import InformationCardOriginal from '../../InformationCard/InformationCard';

export const WalletCard = styled(InformationCardOriginal)`
  margin-bottom: 12px;

  ${({ withDivider }) =>
    !withDivider &&
    `
    > div:last-child {
      padding: 0;
      display: none;
    }
  `}
  > div:nth-child(3) {
    padding: 0px 12px 12px 12px;
  }

  ${({ someCondition }) =>
    someCondition &&
    `
    > div:nth-child(2) {
      padding-bottom: 12px;
    }
  `}
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.h2`
  ${fontTitle(16)};
  margin: 0 0 4px 0;
  color: var(--foreground);
`;

export const Code = styled.span`
  ${fontBody(14)};
  color: var(--muted-foreground);
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const AmountRow = styled.div`
  display: flex;
  align-items: baseline;
`;

export const Currency = styled.span`
  ${fontTitle(26)};
  color: var(--foreground);
`;

export const Amount = styled.span`
  ${fontTitle(28)};
  color: var(--foreground);
  font-weight: 800;
`;

export const SeeDetails = styled.div`
  ${fontBody(12)};
  color: var(--muted-foreground);
  font-weight: 400;
  line-height: 133%;
  letter-spacing: 0.025em;
  text-decoration: underline;
  cursor: pointer;
`;

export const ExpirationSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ExpirationLeft = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ExpirationLabel = styled.span`
  ${fontBody(14)};
  color: ${convertColorToThemeHexCode('red')};
  font-weight: 100;
`;

export const ExpirationRight = styled.div`
  display: flex;
  align-items: center;
`;

export const ExpirationAmount = styled.span`
  ${fontBody(14)};
  color: var(--muted-foreground);
  font-weight: 600;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalTitle = styled.h1`
  ${fontTitle(20)};
  font-weight: 800;
  color: var(--foreground);
  padding: 0;
`;

export const ModalSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalLabel = styled.span`
  ${fontBody(14)};
  color: var(--muted-foreground);
  font-weight: 400;
`;

export const ModalValue = styled.span`
  ${fontBody(14)};
  color: var(--foreground);
  font-weight: 600;
`;

export default {};
